import React from 'react';
export const LicenseField = ({ label, value, variant }) => (React.createElement("div", { style: {
        display: 'flex',
        gap: variant === 'compact' ? '0.5rem' : '1rem',
        alignItems: 'baseline'
    } },
    React.createElement("div", { style: { fontSize: '1rem', textTransform: 'uppercase', color: '#888' } }, label),
    React.createElement("div", { style: {
            fontWeight: '600',
            fontSize: variant === 'compact' ? '1rem' : '1.5rem'
        } }, value)));
export const PropertyGroup = ({ children }) => (React.createElement("div", { style: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.25rem'
    } }, children));
